/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "api-fault",
  role: "status"
};
const _hoisted_2 = ["value"];
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/css'

import { apiFault } from '../services/api-diagnostics.js';
export default {
  __name: 'ApiFaultNotice',
  setup(__props) {
    const fallback = ref('');
    async function copy() {
      const text = JSON.stringify(apiFault.value, null, 2);
      try {
        await navigator.clipboard.writeText(text);
        ElMessage.success('故障信息已复制');
      } catch {
        fallback.value = text;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      return _unref(apiFault) ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString(_unref(apiFault).message), 1), _createElementVNode("small", null, "故障编号：" + _toDisplayString(_unref(apiFault).requestId || _unref(apiFault).faultId), 1)]), _createVNode(_component_el_button, {
        size: "small",
        onClick: copy
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("复制故障信息")])),
        _: 1
      }), _createVNode(_component_el_button, {
        text: "",
        size: "small",
        onClick: _cache[0] || (_cache[0] = $event => apiFault.value = null)
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("关闭")])),
        _: 1
      }), fallback.value ? (_openBlock(), _createElementBlock("textarea", {
        key: 0,
        readonly: "",
        value: fallback.value,
        "aria-label": "故障信息，可选择复制",
        onFocus: _cache[1] || (_cache[1] = $event => $event.target.select())
      }, null, 40, _hoisted_2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }
};